import nextFrame from 'utils/nextFrame';
import createObserver from 'utils/observers/createObserver';

export default function nextFrameCreateObserver (observerType, observerNode, callback, observerConfig = {}) {
  return new Promise((resolve) => {
    nextFrame(() => {
      let node = observerNode;
      if (typeof node === 'function') {
        node = node();
      }

      // do not init observer if node is not present
      if (!node){
        return;
      }
      resolve(createObserver(observerType, node, callback, observerConfig));
    });
  });
}
